module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/